import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { AuthenticationService } from './services/authentication.service';
import { AlertService } from './services/alert.service';
// @HostListener("window:onbeforeunload", ["$event"])
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'AED';
 // public validinput = "^(?:[^()]*|[^()]*\([^()]*\)[^()]*)$";
  public validinput:RegExp = /^[^\s]+(\s+[^\s]+)*$/;
  constructor(dateTimeAdapter: DateTimeAdapter<any>,
    private alertService: AlertService,
    private authenticationService: AuthenticationService,
    private router: Router,) {
    dateTimeAdapter.setLocale('en-in');
  }

  ngOnInit(): void {
    this.authenticationService.broadcastMessage();
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (e.url === '/tripreport' || e.url === '/tripsimulationreport' || e.url.startsWith('/tripsimulationreport')
          || e.url.startsWith('/serviceschedules') || e.url.startsWith('/targets') || e.url.startsWith('/tariffs')
          || e.url.startsWith('/regions') || e.url.startsWith('/regions') || e.url.startsWith('/divisions')
          || e.url.startsWith('/subdivisions') || e.url.startsWith('/consumables') || e.url.startsWith('/workshops')
          || e.url.startsWith('/providers')
          || e.url.startsWith('/users/')
          || e.url.startsWith('/devices/')
          || e.url.startsWith('/vehicles/')
          || e.url.startsWith('/implements/')
          || e.url.startsWith('/drivers/')
          || e.url.startsWith('/fuellog/')
          || e.url.startsWith('/tripentries/')
          || e.url.startsWith('/servicelog/')
          || e.url.startsWith('/consumableentries/')
          || e.url.startsWith('/expenseentries/')
          // ||e.url === ('/auth/paymentsuccess')
          // ||e.url === ('/auth/paymentfailure')
          ) {
          document.body.classList.add('removeglobalfilter');
        } else {
          document.body.classList.remove('removeglobalfilter');
        }
      }
    });
  }

  clearAllData() {
    // this.authService.logOut();
  }

  @HostListener('document:input', ['$event'])
  handleInput(event: InputEvent): void {
    if (event.target instanceof HTMLInputElement) {
      const inputElement = event.target as HTMLInputElement;
      const inputValue = inputElement.value;
      // Replace < and > with empty string
      inputElement.value = inputValue.replace(/[<>]/g, '');
      // Emit an input event to update ngModel or form controls
      inputElement.dispatchEvent(new Event('input'));
    }
  }


}
